import ConfirmationModal from "../Components/ConfirmationModal";
import React from "react";
import * as PropTypes from "prop-types";
import {faIcons} from "../../utils/iconConstants";

export const DeleteMarketPeriod = (props) => {
    return <>
        <i
            title={"Delete"}
            className={faIcons.delete}
            onClick={props.onClick}
            data-testid={"delete-market-period"}
        />
        {
            props.deleteModalOpen &&
            <ConfirmationModal confirmationCallback={props.confirmationCallback}
                               cancellationCallback={props.cancellationCallback}
                               modalClassName={"DeleteModal"}
                               headerText={`Delete - Period ${props.selectedMarketPeriod}`}

            >
                <div>{`Are you sure you want to delete Period ${props.selectedMarketPeriod}?`}</div>
            </ConfirmationModal>
        }
    </>;
}

DeleteMarketPeriod.propTypes = {
    onClick: PropTypes.func,
    deleteModalOpen: PropTypes.bool,
    confirmationCallback: PropTypes.func,
    cancellationCallback: PropTypes.func,
    selectedMarketPeriod: PropTypes.any
};